export const UserStatisticsVisibility = {
    MediumStrict: 0, // hide all user information regarding usage and individual statistics
    SchoolMode: 1,
    Strict: 2,
}
Object.freeze(UserStatisticsVisibility)
